import {Component, OnDestroy, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";

import {IGoPageConfig} from "../../definitions";
import {GO_COMPONENTS} from "../../enums/e-game-objects";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {DOCUMENT_TYPES} from "../../enums/enums";
import {BusService} from "../../services/bus.service";
import {paramsHelper} from "../../helpers/params-helper";
import {UI_TEXTS} from "../../enums/e-texts";
import {IDocument} from "../../interfaces/document.definition";
import {localeUtils} from "../../helpers/locale-utils";
import {AnimationsService, IAnimationInfo} from "../../services/animations.service";
import {Subject} from "rxjs/Subject";


@Component({
  templateUrl: "./go-page.component.html"
})


export class GoPageComponent implements OnInit, OnDestroy {
  UI_TEXTS = UI_TEXTS;
  pageParams = paramsHelper.page()
    .setTitle("Гейм-объекты");

  collectionParams = paramsHelper.collection()
    .setObjectType(DOCUMENT_TYPES.GO)
    .setDefaultListLabels()
    .setItemLabelQuery(`locales.${localeUtils.getLocale()}.[key=name].value.0`)
    .setSearchParams(paramsHelper.search()
      .addNumberParam("id")
      .addStringParam('tagsComponent')
      .addStringParam('category')
      .addNumberParam('gameEventsComponent')
      .addParam(`locales.${localeUtils.getLocale()}.name`, SEARCH_PROP_TYPES.LOCALE, ""));

  COMPS = GO_COMPONENTS;
  goPageConf: IGoPageConfig;

  document: IDocument;
  private unsubscribe: Subject<void> = new Subject<void>();


  constructor(private activatedRoute: ActivatedRoute,
              private busService: BusService,
              private animationsService:AnimationsService) {

  }


  isEnabled(componentType: string): boolean {
    return this.goPageConf.components.indexOf(componentType) >= 0;
  }


  ngOnInit(): void {
    this.goPageConf = this.activatedRoute.snapshot.data as IGoPageConfig;
    this.pageParams.setTitle(this.goPageConf.name);
    this.pageParams.setSubtitle(this.goPageConf.categories.join(","));

    const filterParams = paramsHelper.search()
      .addParam("category", SEARCH_PROP_TYPES.ENUM_MULTI, this.goPageConf.categories);

    this.collectionParams.setObjectSubtypes(this.goPageConf.categories);
    this.collectionParams.setFilterParams(filterParams);

    this.busService.onDocumentUpdated
      .takeUntil(this.unsubscribe)
      .subscribe(
        e => this.onDocumentUpdated(e.document));
  }

  ngOnDestroy(){
    console.log('page destroy');
    this.unsubscribe.next();
    this.unsubscribe.complete();

  }

  private onDocumentUpdated(document:IDocument)
  {
    if (document!=null)
    {
      this.loadAnimationInfo(document);
    }
  }


  private loadAnimationInfo(document:IDocument) {
    this.animationsService
      .loadInfo("animation", document.id.toString(), document._type, null)
      .takeUntil(this.unsubscribe)
      .subscribe(
        a => {
          let animationInfo:IAnimationInfo = a;
          if (animationInfo.content.length > 0)
          {
            this.pageParams.setOnDeleteMessage("Не удалить! Сначала удали спайн-ассеты. После удаления нужно перепаковать.");
          }
          else
          {
            this.pageParams.setOnDeleteMessage("");
          }
          this.document = document;
        });
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/go/go-page.component.ts